export default __webpack_public_path__ + "static/WEGC-UniGraz_Logo_medium-5052e1515e7793b37fa117877974ceb0.png";